import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { TabComponent } from '@sde/widgets-core/src/common/TabComponent';
import PropTypes from 'prop-types';
import { getDomain } from 'src/tools/getDomain';
import { usePayers } from '@sde/widgets-core/src/redux/resources/payers';

import { AdditionalLinks } from './AdditionalLinks';

const MarginedDivider = styled.div({
  margin: '0px auto 10px',
});

const StyledH2 = styled('h2', {
  fontFamily: 'AbyssUHCSerif, Georgia Bold, serif',
  color: '$primary1',
});

export const EligibilityRightRails = (user, toggleModal, dashboard) => {
  const domain = getDomain('sde-eligibility', 3100);

  return [
    <AdditionalLinks
      user={user}
      toggleModal={toggleModal}
      key="additional-links"
    />,
    <abyss-parcel
      scriptdomain={domain}
      import="eligibility-recent-eligibility-search-list@dev"
      user={JSON.stringify(user)}
      toggleModal={toggleModal}
      dashboard={JSON.stringify(dashboard)}
    />,
  ];
};

const EligibilitySearchComponent = ({
  user,
  payer,
  provider,
  modals,
  modalData,
  dashboard,
  providerPreferenceComplete,
}) => {
  const domain = getDomain('sde-eligibility', 3100);
  const { payers } = usePayers.state();

  return (
    <React.Fragment>
      <MarginedDivider>
        <StyledH2>Verify Eligibility & Benefits</StyledH2>
      </MarginedDivider>
      <abyss-parcel
        import="eligibility-search@dev"
        scriptdomain={domain}
        stretch
        showLoading
        isEligibilityTab
        loadingStyles={{ position: 'initial' }}
        user={JSON.stringify(user)}
        payer={JSON.stringify(payer)}
        provider={JSON.stringify(provider)}
        payers={JSON.stringify(payers)}
        modals={JSON.stringify(modals)}
        modalData={JSON.stringify(modalData)}
        dashboard={JSON.stringify(dashboard)}
        providerPreferenceComplete={JSON.stringify(providerPreferenceComplete)}
      />
    </React.Fragment>
  );
};

export const EligibilitySearch = (props) => {
  return (
    <TabComponent
      component={<EligibilitySearchComponent {...props} />}
      rightRails={EligibilityRightRails(props.user, props.toggleModal)}
      tabName="Eligibility"
    />
  );
};

EligibilitySearch.propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
};
